import React from 'react';
import { CountdownTimer } from './Countdown';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL } from '../utils/constants';
export function FinalCta() {
  return <section aria-labelledby="final-cta-title" className="w-full bg-petrol px-3 py-7 sm:px-5" data-id="element-75" data-mp="19g0d3ipnhwkf">
      <div className="mx-auto max-w-2xl text-center" data-id="element-76" data-mp="15d3ys4758mma">
        <span className="inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[10px] uppercase tracking-wide text-white sm:text-xs" data-id="element-77" data-mp="15fq7461uz65k">
          Limited-Time Offer
        </span>
        <h2 id="final-cta-title" className="mt-1 font-head text-2xl uppercase leading-[0.98] text-white sm:text-4xl" data-id="element-78" data-mp="1ebxt1nx050wo">
          Complete your professional teaching system today
        </h2>

        <CountdownTimer className="mt-2" tone="light" data-id="element-79" data-mp="1o4n1sb1640ob" />

        <div className="mt-3 rounded-2xl bg-cream p-4" data-id="element-80" data-mp="222uxkfmgwvxw">
          <h3 className="font-head text-xl uppercase leading-none text-ink sm:text-3xl" data-id="element-81" data-mp="221a0ai8rqywc">
            Special Education Teacher Pro™
          </h3>
          <p className="mt-0.5 text-[11px] text-muted sm:text-sm" data-id="element-82" data-mp="n6nu779cel10">
            Complete 6-in-1 Box Set + 5 Strategic Bonuses
          </p>
          <p className="mt-1.5 text-[13px] text-muted" data-id="element-83" data-mp="s6s063cmjxcz">
            Regular Price: <span className="line-through" data-id="element-84" data-mp="x2z8u3wenmym">$97</span>
          </p>
          <p className="font-head text-4xl leading-none text-petrol sm:text-5xl" data-id="element-85" data-mp="123ejuot7sidf">TODAY: $27</p>
          <span className="mt-1 inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[11px] uppercase tracking-wide text-white" data-id="element-86" data-mp="164qamxntr9n7">
            Save $70
          </span>

          <div className="mt-3 flex flex-col items-center" data-id="element-87" data-mp="1b1713yihy03g">
            <CtaButton href={CHECKOUT_URL} data-id="element-88" data-mp="1fvl34jrnz5h3" />
            <TrustRow className="mt-2" accessLabel="Instant Digital Access" data-id="element-89" data-mp="1ktd1nwmtdpu9" />
          </div>
        </div>
      </div>
    </section>;
}